// --------------------------------------------------------------------------
// #34 – Membership form
//     - Handles toggling elements visibility within the membership journey
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

/* global dataLayer */

'use strict';

var $ = require('jquery');
var events = require('common-js-pub-sub')();

module.exports = function (options) {
    var context = options.context;

    var membershipGaEvent = {
        membershipType: context.attr('data-membershiptype')
    };

    var completedSections = [];
    var membershipStep = window.location.hash.match(/(#step\d+)/g) === null ? 1 : window.location.hash.replace(/(#step)/g, '');

    var isSingleStepMembership = context.attr('data-membershiptype') === 'Individual' || context.attr('data-membershiptype') === 'Joint' ? true : false;

    /**
     * Google tag manager function
     */
    function pushGaPartialCompletionDataLayer(completedSectionName, completedSectionIndex) {
        var membershipType = membershipGaEvent.membershipType;
        var currentStep = window.location.hash.match(/(#step\d+)/g) === null ? 1 : window.location.hash.replace(/(#step)/g, '');
        var membershipStepSection = $(completedSectionName).contents().first().text();
        membershipStepSection = membershipStepSection.replace(/(^\s+|\s+$)/g, '');

        if (currentStep > membershipStep) {
            //only if user is moving forward in membership journey
            membershipStep = currentStep;
            completedSections = [];
        }

        if (completedSections.indexOf(completedSectionIndex) === -1) {
            completedSections.push(completedSectionIndex);
            dataLayer.push({ 'event': 'membershipSectionComplete', 'membershipType': membershipType, 'stepNumber': currentStep, 'sectionName': membershipStepSection });
        }
    }

    function closeFieldset(options) {
        var callback = options.callback || function () {};
        options.closeThis.slideUp(function () {
            callback();
        });
    }

    function openFieldset(options) {
        var visible = $(options.openThis[0]).is(':visible');
        var title = $(options.openThis[0]).parents('[class*="membership-form-section"]');

        function scrollToElement() {
            var offset = title.offset().top;
            $('html, body').animate({
                scrollTop: offset
            }, 500);
        }

        options.openThis.slideDown({
            done: function done() {
                if (!visible) {
                    scrollToElement();
                } else {
                    setTimeout(function () {
                        scrollToElement();
                    }, 400);
                }
            }
        });
    }

    function toggleFieldset(options) {
        options.toggleThis.slideToggle();
    }

    function closeCurrentFieldset(options) {
        if (!isIndividualMembership) {
            closeFieldset({
                closeThis: options.fieldset
            });
        }
    }

    function openNextFieldset(options) {
        if (!isIndividualMembership) {
            openFieldset({
                openThis: options.fieldset
            });
            pushGaPartialCompletionDataLayer(options.completedLabel, options.index);
        }
    }

    function validatePostcodeAndManualAdress(buttonClicked) {
        var errorCount = 0;
        var form = context.find('form');
        var formSection = buttonClicked.parents('.membership-form-section__content');
        var formFields = formSection.find('input:visible, select:visible');
        var postcodeField = context.find('[data-binding="postcode-lookup-input-field"]');
        var postcodeFieldExists = postcodeField.length > 0;
        var isPostcodeEmpty;
        var manualAddressExists = $('[data-binding="edit-address-fields"]').length > 0;
        var manualAddressDisplay;

        if (postcodeFieldExists) {
            isPostcodeEmpty = postcodeField.val() === '';
        }

        if (manualAddressExists) {
            manualAddressDisplay = $('[data-binding="edit-address-fields"]').css('display');
        }

        for (var counter = 0; counter < formFields.length; counter++) {
            if (!form.validate().element(formFields[counter])) {
                errorCount++;
            }
        }

        if (postcodeFieldExists && postcodeField.is(':visible') && isPostcodeEmpty === true && manualAddressDisplay !== 'block') {
            errorCount++;
            postcodeField.siblings('span').removeClass('field-validation-valid').addClass('field-validation-error').text('Please enter a postcode or enter your address manually');
        }

        if (manualAddressExists && manualAddressDisplay === 'block') {
            var fields = $('[data-binding="address-part-street-address"], [data-binding="address-part-town"]');

            for (var fieldCounter = 0; fieldCounter < fields.length; fieldCounter++) {
                if (!context.find('form').validate().element(fields[fieldCounter])) {
                    errorCount++;
                }
            }
        }

        return errorCount;
    }

    events.subscribe('scroll-to-error', function () {
        var firstError = context.find('.field-validation-error').first();
        var firstErrorSectionContent = firstError.parents('.membership-form-section__content');
        var errorInput = firstError.siblings('input, select');

        if (firstError.parents('[data-binding="edit-address-fields"]').length > 0) {
            $('[data-binding="edit-address-fields"]').slideDown();
        }

        firstErrorSectionContent.slideDown(function () {
            var offsetTop = errorInput.length > 0 ? errorInput.offset().top : firstError.offset().top;
            $('html, body').animate({
                scrollTop: offsetTop
            }, 500);
        });
    });

    /**
     * Update the price displayed on payment options
     */
    function updatePaymentMethodPrice(amount) {
        var price = amount.replace('.00', '');
        var priceAnnual = price * 12;
        var paymentMonthlyLabel;
        var paymentAnnuallyLabel;
        var paymentAnnualyCardLabel;

        // Restrict decimal places to 2
        // Remove decimal places if they are 00
        priceAnnual = priceAnnual.toFixed(2);

        // update hidden x_amount field for credit card submit
        $('input[name="x_amount"]').val(priceAnnual);
        priceAnnual = priceAnnual.replace('.00', '');

        // Get the monthly payment label, remove text node with amount and append new text node with update amount
        paymentMonthlyLabel = $('#payment-monthly').next();
        paymentMonthlyLabel.contents().last().remove();
        paymentMonthlyLabel.append('£' + price + ' via direct debit');

        // Get the monthly payment label, remove text node with amount and append new text node with update amount
        paymentAnnuallyLabel = $('#payment-annually').next();
        paymentAnnuallyLabel.contents().last().remove();
        paymentAnnuallyLabel.append('£' + priceAnnual + ' via direct debit');

        // Get the monthly payment label, remove text node with amount and append new text node with update amount
        paymentAnnualyCardLabel = $('#payment-oneoff').next();
        paymentAnnualyCardLabel.contents().last().remove();
        paymentAnnualyCardLabel.append('£' + priceAnnual + ' via credit / debit card');
    }

    function init() {

        if (isSingleStepMembership) {
            // update custom amount price on membership payment methods on page reload
            if ($('#PriceOptions_CustomAmount').val() !== '') {
                updatePaymentMethodPrice($('#PriceOptions_CustomAmount').val());
            }
        }

        context.on('click', '.toggle', function (e) {
            e.preventDefault();
            toggleFieldset({
                toggleThis: $(this).parent().siblings('.membership-form-section__content')
            });
        });

        context.on('change', '[data-binding="price-input-option"]', function () {

            var gift = $(this).parents('.membership-form-section--gift').length;
            var joint = $(this).parents('.membership-form-section--joint').length;
            var family = $(this).parents('.membership-form-section--family').length;

            if (gift > 0 && joint === 0 || gift === 0 && joint > 0 || family > 0) {

                closeCurrentFieldset({
                    fieldset: $(this).parents('.membership-form-section__content')
                });

                openNextFieldset({
                    completedLabel: $(this).closest('fieldset').children('.membership-form-section__heading'),
                    fieldset: $(this).parents('[class*="membership-form-section"]').next().find('.membership-form-section__content'),
                    index: $(this).closest('fieldset').parents('[class*="membership-form-section"]').index()
                });
            }

            // Update amount on payment option for membership one page application
            if (isSingleStepMembership) {
                updatePaymentMethodPrice($(this).val());
            }
        });

        context.on('change', 'input.incentive', function () {

            if ($(this).parents('[data-binding="membership-gift-details"]').length < 1) {

                closeCurrentFieldset({
                    fieldset: $(this).parents('.membership-form-section__content')
                });

                openNextFieldset({
                    completedLabel: $(this).closest('fieldset').children('.membership-form-section__heading'),
                    fieldset: $(this).parents('.membership-form-section').next().find('.membership-form-section__content'),
                    index: $(this).closest('fieldset').parents('[class*="membership-form-section"]').index()
                });
            }
        });

        context.on('click', '.confirm-address-button', function (e) {
            e.preventDefault();

            if (context.find('form').valid()) {

                closeCurrentFieldset({
                    fieldset: $(this).parents('.membership-form-section__content')
                });

                openNextFieldset({
                    completedLabel: $(this).closest('fieldset').children('.membership-form-section__heading'),
                    fieldset: $(this).parents('[class*="membership-form-section"]').next().find('.membership-form-section__content'),
                    index: $(this).closest('fieldset').parents('[class*="membership-form-section"]').index()
                });
            }
        });

        context.on('click', '[data-binding="next-section"]', function (e) {
            e.preventDefault();

            var errorCount = validatePostcodeAndManualAdress($(this));

            if (errorCount === 0) {
                closeCurrentFieldset({
                    fieldset: $(this).parents('.membership-form-section__content')
                });

                openNextFieldset({
                    completedLabel: $(this).closest('fieldset').children('.membership-form-section__heading'),
                    fieldset: $(this).parents('[class*="membership-form-section"]').next().find('.membership-form-section__content'),
                    index: $(this).closest('fieldset').parents('[class*="membership-form-section"]').index()
                });
            } else {
                events.publish('scroll-to-error');
            }
        });

        context.on('change', 'input.payment-type', function () {
            var toShow = null;

            if ($(this).val() === 'OneOff') {
                toShow = context.find('.credit-card-payment');
                context.find('.direct-debit-payment').hide();
                toShow.show();
                $.validator.unobtrusive.parse(toShow.find('form'));
            } else {
                toShow = context.find('.direct-debit-payment');
                context.find('.credit-card-payment').hide();
                toShow.show();
                $.validator.unobtrusive.parse(toShow.find('form'));
            }

            if (validatePostcodeAndManualAdress($(this)) === 0) {
                closeCurrentFieldset({
                    fieldset: $(this).parents('.membership-form-section__content')
                });

                openNextFieldset({
                    completedLabel: $(this).closest('fieldset').children('.membership-form-section__heading'),
                    fieldset: toShow.find('.membership-form-section__content'),
                    index: $(this).closest('fieldset').parents('[class*="membership-form-section"]').index()
                });
            } else {
                events.publish('scroll-to-error');
            }
        });

        context.on('keydown', '[data-binding="custom-amount-text-box"]', function (e) {
            var numberOfFieldsets = $('fieldset').length;
            if (e.keyCode === 13 && context.find('form').valid() && numberOfFieldsets > 1) {
                e.preventDefault();
                closeCurrentFieldset({
                    fieldset: $(this).parents('.membership-form-section__content')
                });

                openNextFieldset({
                    completedLabel: $(this).closest('fieldset').children('.membership-form-section__heading'),
                    fieldset: $(this).parents('[class*="membership-form-section"]').next().find('.membership-form-section__content'),
                    index: $(this).closest('fieldset').parents('[class*="membership-form-section"]').index()
                });
            }
        });

        context.on('keyup', '[data-binding="custom-amount-text-box"]', function () {
            // Update amount on payment option for membership one page application
            if (isSingleStepMembership) {
                updatePaymentMethodPrice($(this).val());
            }
        });
    }

    function closeFieldset(options) {
        var callback = options.callback || function () {};
        options.closeThis.slideUp(function () {
            callback();
        });
    }

    function openFieldset(options) {
        var visible = $(options.openThis[0]).is(':visible');
        var title = $(options.openThis[0]).parents('[class*="membership-form-section"]');

        function scrollToElement() {
            var offset = title.offset().top;
            $('html, body').animate({
                scrollTop: offset
            }, 500);
        }

        options.openThis.slideDown({
            done: function done() {
                if (!visible) {
                    scrollToElement();
                } else {
                    setTimeout(function () {
                        scrollToElement();
                    }, 400);
                }
            }
        });
    }

    function toggleFieldset(options) {
        options.toggleThis.slideToggle();
    }

    function closeCurrentFieldset(options) {
        if (!isSingleStepMembership) {
            closeFieldset({
                closeThis: options.fieldset
            });
        }
    }

    function openNextFieldset(options) {
        if (!isSingleStepMembership) {
            openFieldset({
                openThis: options.fieldset
            });
            pushGaPartialCompletionDataLayer(options.completedLabel, options.index);
        }
    }

    function validatePostcodeAndManualAdress(buttonClicked) {
        var errorCount = 0;
        var form = context.find('form');
        var formSection = buttonClicked.parents('.membership-form-section__content');
        var formFields = formSection.find('input:visible, select:visible');
        var postcodeField = context.find('[data-binding="postcode-lookup-input-field"]');
        var postcodeFieldExists = postcodeField.length > 0;
        var isPostcodeEmpty;
        var manualAddressExists = $('[data-binding="edit-address-fields"]').length > 0;
        var manualAddressDisplay;

        if (postcodeFieldExists) {
            isPostcodeEmpty = postcodeField.val() === '';
        }

        if (manualAddressExists) {
            manualAddressDisplay = $('[data-binding="edit-address-fields"]').css('display');
        }

        for (var counter = 0; counter < formFields.length; counter++) {
            if (!form.validate().element(formFields[counter])) {
                errorCount++;
            }
        }

        if (postcodeFieldExists && postcodeField.is(':visible') && isPostcodeEmpty === true && manualAddressDisplay !== 'block') {
            errorCount++;
            postcodeField.siblings('span').removeClass('field-validation-valid').addClass('field-validation-error').text('Please enter a postcode or enter your address manually');
        }

        if (manualAddressExists && manualAddressDisplay === 'block') {
            var fields = $('[data-binding="address-part-street-address"], [data-binding="address-part-town"]');

            for (var fieldCounter = 0; fieldCounter < fields.length; fieldCounter++) {
                if (!context.find('form').validate().element(fields[fieldCounter])) {
                    errorCount++;
                }
            }
        }

        return errorCount;
    }

    /**
     * Google tag manager function
     */
    function pushGaPartialCompletionDataLayer(completedSectionName, completedSectionIndex) {
        var membershipType = membershipGaEvent.membershipType;
        var currentStep = window.location.hash.match(/(#step\d+)/g) === null ? 1 : window.location.hash.replace(/(#step)/g, '');
        var membershipStepSection = $(completedSectionName).contents().first().text();
        membershipStepSection = membershipStepSection.replace(/(^\s+|\s+$)/g, '');

        if (currentStep > membershipStep) {
            //only if user is moving forward in membership journey
            membershipStep = currentStep;
            completedSections = [];
        }

        if (completedSections.indexOf(completedSectionIndex) === -1) {
            completedSections.push(completedSectionIndex);
            dataLayer.push({ 'event': 'membershipSectionComplete', 'membershipType': membershipType, 'stepNumber': currentStep, 'sectionName': membershipStepSection });
        }
    }

    events.subscribe('scroll-to-error', function () {
        var firstError = context.find('.field-validation-error').first();
        var firstErrorSectionContent = firstError.parents('.membership-form-section__content');
        var errorInput = firstError.siblings('input, select');

        if (firstError.parents('[data-binding="edit-address-fields"]').length > 0) {
            $('[data-binding="edit-address-fields"]').slideDown();
        }

        firstErrorSectionContent.slideDown(function () {
            var offsetTop = errorInput.length > 0 ? errorInput.offset().top : firstError.offset().top;
            $('html, body').animate({
                scrollTop: offsetTop
            }, 500);
        });
    });

    /**
     * Update the price displayed on payment options
     */
    function updatePaymentMethodPrice(amount) {
        var price = amount.replace('.00', '');
        var priceAnnual = price * 12;
        var paymentMonthlyLabel;
        var paymentAnnuallyLabel;
        var paymentAnnualyCardLabel;

        // Restrict decimal places to 2
        // Remove decimal places if they are 00
        priceAnnual = priceAnnual.toFixed(2);

        // update hidden x_amount field for credit card submit
        $('input[name="x_amount"]').val(priceAnnual);
        priceAnnual = priceAnnual.replace('.00', '');

        // Get the monthly payment label, remove text node with amount and append new text node with update amount
        paymentMonthlyLabel = $('#payment-monthly').next();
        paymentMonthlyLabel.contents().last().remove();
        paymentMonthlyLabel.append('£' + price + ' via direct debit');

        // Get the monthly payment label, remove text node with amount and append new text node with update amount
        paymentAnnuallyLabel = $('#payment-annually').next();
        paymentAnnuallyLabel.contents().last().remove();
        paymentAnnuallyLabel.append('£' + priceAnnual + ' via direct debit');

        // Get the monthly payment label, remove text node with amount and append new text node with update amount
        paymentAnnualyCardLabel = $('#payment-oneoff').next();
        paymentAnnualyCardLabel.contents().last().remove();
        paymentAnnualyCardLabel.append('£' + priceAnnual + ' via credit / debit card');
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/membership-form-toggle.js
// module id = 187
// module chunks = 0